var exports = {
  "kL": "x127c5a35--285d21--container",
  "Qs": "x127c5a35--285d21--content",
  "DD": "x127c5a35--285d21--title",
  "h_": "x127c5a35--285d21--description",
};

module.exports = exports;
